export const styles = {
    infoLine: {
        width: '100%',
        height: '1px',
        background: '#C1C4CC',
        my: '12px',
    },
};
